import { FaGithub } from "react-icons/fa";
import { SiVelog } from "react-icons/si";
import { FaInstagram } from "react-icons/fa";

const Icons = {
    github : <FaGithub size='80%'/>,
    velog : <SiVelog size='70%'/>,
    instagram : <FaInstagram size='80%'/>, 

}

export default Icons;
